import { useMemo, useState } from "react";
import PropTypes from "prop-types";
import PolymorphicGrid from "./PolymorphicGrid";
import { Provider } from "react-redux";

const PolymorphicTasks = ({ agent, taskable }) => {
  const store = useMemo(() => ReactOnRails.getStore("layoutStore"), []);
  const [isLoading, setIsLoading] = useState(false);
  return (
    <Provider store={store}>
      <div>
        {agent && (
          <div>
            <PolymorphicGrid
              duenessTitle="Upcoming Task Details"
              agent={agent}
              pagination={{}}
              taskable={taskable}
              dueness="incomplete"
              scopes={["incomplete"]}
              selectAllClass="none"
              createButton
              uncomplete={false}
              multiSelectButtons
              polymorphicTasks
              toggleTaskLoader={setIsLoading}
            />
            <PolymorphicGrid
              duenessTitle="Contingent Task Details"
              agent={agent}
              taskable={taskable}
              scopes={["contingent_tasks"]}
              dueness="contingent"
              pagination={{}}
              selectAllClass="little-more-space"
              createButton={false}
              uncomplete={false}
              multiSelectButtons
              polymorphicTasks
              toggleTaskLoader={setIsLoading}
            />
          </div>
        )}
        {agent && (
          <PolymorphicGrid
            duenessTitle="Completed Task Details"
            agent={agent}
            pagination={{}}
            scopes={["complete_tasks"]}
            dueness="completed"
            taskable={taskable}
            selectAllClass="little-more-space"
            createButton={false}
            uncomplete
            multiSelectButtons={false}
            polymorphicTasks
            toggleTaskLoader={setIsLoading}
          />
        )}
        {!agent && (
          <PolymorphicGrid
            duenessTitle="Completed Task Details"
            agent={agent}
            pagination={{}}
            scopes={["complete_tasks", "is_public"]}
            dueness="completed"
            taskable={taskable}
            selectAllClass="little-more-space"
            createButton={false}
            uncomplete
            multiSelectButtons={false}
            polymorphicTasks
            toggleTaskLoader={setIsLoading}
          />
        )}
      </div>
    </Provider>
  );
};

PolymorphicTasks.propTypes = {
  user: PropTypes.object.isRequired,
};

PolymorphicTasks.defaultProps = {
  tasks: [],
  user: { name: "No Name" },
  pagination: {},
};

export default PolymorphicTasks;
